import { getLocalstorageItem, setLocalstorageItem } from '@/helpers/localStorage';
import { getSubdomain } from '@/helpers/util';

export const setGoogleTagManager = async () => {
  insertGoogleTagManager(getStoredGoogleTag());
};

function getStoredGoogleTag() {
  return getLocalstorageItem(getSubdomain() + '.google-manager-tag-id');
}

export function storeGoogleTag(tagId) {
  setLocalstorageItem(getSubdomain() + '.google-manager-tag-id', tagId, 999);
}

export const insertGoogleTagManager = (tagId) => {
  window.initGTagManager(tagId);

  const noscript = document.querySelector('#google-tag-noscript');
  noscript.setAttribute('scr', 'https://www.googletagmanager.com/ns.html?id=' + tagId);
};
